import MaterialIcons from "@expo/vector-icons/MaterialIcons";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import React from "react";
import { OpaqueColorValue, TextStyle } from "react-native";

// Icons that exist in MaterialIcons (use these names to prefer MI rendering)
const MATERIAL_ICONS: Set<string> = new Set([
  "person",
  "timer",
  "info",
  "business",
  "calendar-month",
  "smartphone",
  "handyman",
  "message",
  "attach-money",
  "dashboard",
  "people-alt",
  "science",
  "schedule",
  "punch-clock",
  "school",
  "calculate",
  "warning",
  "search",
  "receipt",
  "payment",
  "person-add",
  "chevron-right",
]);

export type IconSymbolName =
  | React.ComponentProps<typeof MaterialIcons>["name"]
  | React.ComponentProps<typeof MaterialCommunityIcons>["name"];

/**
 * Renders MaterialIcons or MaterialCommunityIcons.
 * Tries MaterialIcons first if the icon is in the known MI set, otherwise uses MCI.
 */
export function IconSymbol({
  name,
  size = 24,
  color,
  style,
}: {
  name: IconSymbolName;
  size?: number;
  color: string | OpaqueColorValue;
  style?: TextStyle;
}) {
  // If it's a known MaterialIcons name, use MI
  if (MATERIAL_ICONS.has(name)) {
    return (
      <MaterialIcons
        color={color}
        size={size}
        name={name as React.ComponentProps<typeof MaterialIcons>["name"]}
        style={style}
      />
    );
  }

  // Otherwise use MaterialCommunityIcons
  return (
    <MaterialCommunityIcons
      color={color}
      size={size}
      name={name as React.ComponentProps<typeof MaterialCommunityIcons>["name"]}
      style={style}
    />
  );
}
